export const ACCEPT_EULA = '[eula] accept eula';
export const PROCESS_EULA = '[eula] process eula acceptance';
export const EULA_ERROR = '[eula] error';

export const acceptEula = (history) => ({
  type: ACCEPT_EULA,
  payload: history,
});

export const processEula = () => ({
  type: PROCESS_EULA,
});

export const eulaError = () => ({
  type: EULA_ERROR,
});
